<template>
  <router-view />
</template>

<script>
import { applyThirdPartyId } from "@/common/utils";
import { mapState } from "vuex";
import { QUESTIONS_MODULE } from "@/store/types/module-types";
export default {
  name: "TenantsLayout",
  props: {
    urlParams: Object,
  },
  computed: {
    ...mapState(QUESTIONS_MODULE, ["userId"]),
  },
  async mounted() {
    try {
      applyThirdPartyId(false, this.userId);
      return;
    } catch (e) {
      console.error(e);
    }
  },
};
</script>
